module.exports = __webpack_public_path__ + "static/media/green-card-back-example.4527acbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/green-card-back-example.png
// module id = 844
// module chunks = 0